import React from 'react';
import inspirationBackground from '../assets/Frame.svg'; // Tu SVG

function InspirationSection() {
  return (
    <section className="relative py-60">
      <img src={inspirationBackground} alt="Hero Background" className="absolute inset-0 w-full h-full object-cover" />
      <div className="relative container mx-auto px-4">
        <h1 className="text-4xl md:text-4xl font-bold font-montserrat mb-6">Miles de aventuras a un click de distancia.</h1>
        <p className="text-xl font-open-sans mb-4">Complí ese sueño que tanto querés</p>
      </div>
    </section>
  );
}

export default InspirationSection;